import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['successModalContainer'];

  confirmSend(event) {
    event.preventDefault();

    // Fecha o modal de confirmação atual
    // Busca o modal de confirmação que está aberto atualmente
    const currentButton = event.currentTarget;
    const confirmModalContainer = currentButton.closest('[data-controller*="v3--modal"]');

    if (confirmModalContainer) {
      const modalElement = confirmModalContainer.querySelector('dialog');
      if (modalElement) {
        modalElement.close();
      }
    }

    // Abre o modal de sucesso após um pequeno delay
    setTimeout(() => {
      if (this.hasSuccessModalContainerTarget) {
        // Encontra o dialog dentro do container do modal de sucesso
        const dialogElement = this.successModalContainerTarget.querySelector('dialog');
        if (dialogElement) {
          dialogElement.showModal();
        }
      }
    }, 300);
  }
}
